import React, { useEffect, useRef, useState } from 'react';
import { Newsgrid, Newsgrid2, Newsgrid3, VideoPlayer } from '../components/Index';
import { useAppSelector } from '../store/hooks';
import { useSwipe } from '../store/useSwipe';
import { ArticleItem } from '../types/typedeclaration';
import fetchData from 'Utilis/request';
import {HEADING_STYLE_DARK_MODE, HEADING_STYLE_LIGHT_MODE} from '../Config/config';

// Define types for better TypeScript support
type ApiError = {
  message: string;
  status?: number;
};
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export default function LiveTv() {
  const { onTouchStart, onTouchMove, onTouchEnd } = useSwipe();
  const darkMode = useAppSelector((state: any) => state.categoryNavigation.darkmode);
  const fontSize = useAppSelector((state: any) => state.categoryNavigation.fontsize);
  const headerHeight = useAppSelector((state: any) => state.categoryNavigation.headerHeight || 0);
  const fooNavHeight = useAppSelector((state: any) => state.categoryNavigation.fooNavHeight || 0);
  const newsContainerRef = useRef<HTMLDivElement>(null);
  const [articles, setArticles] = useState<ArticleItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<ApiError | null>(null);
  const [retryCount, setRetryCount] = useState(0);

  const fetchVideos = async () => {
    if (loading) return;
    
    setLoading(true);
    setError(null);

    try {      
       const data = await fetchData.getResult(`${API_BASE_URL}getArticleLatest.php`);       
      if (!data) {
        throw new Error('No data received from API');
      }

      const items = data?.articles || [];
      
      if (!Array.isArray(items)) {
        throw new Error('Invalid data format received');
      }

      setArticles(items);
      
    } catch (err:any) {
      console.error("Error fetching videos:", err);
      
      const apiError: ApiError = {
        message: err instanceof Error ? err.message : 'Failed to fetch news articles',
        status: err.response?.status
      };
      
      setError(apiError);
      
      // Auto-retry logic (max 3 retries)
      if (retryCount < 3) {
        setTimeout(() => {
          setRetryCount(prev => prev + 1);
          fetchVideos();
        }, 3000 * (retryCount + 1)); // Exponential backoff
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVideos();
  }, []);

  const handleRetry = () => {
    setRetryCount(0);
    fetchVideos();
  };

  const renderContent = () => {
    if (loading && articles.length === 0) {
      return (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
        </div>
      );
    }

    if (error) {
      return (
        <div className="text-center p-8">
          <p className="text-red-500 mb-4">{error.message}</p>
          {retryCount < 3 ? (
            <p className="text-gray-500 mb-4">Retrying in {3 - retryCount} attempts...</p>
          ) : (
            <button
              onClick={handleRetry}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            >
              Retry
            </button>
          )}
        </div>
      );
    }

    return (
      <>
        <div className='player-media'>
          <VideoPlayer />
          {/* <div className="w-full max-w-[1200px] mx-auto aspect-video overflow-hidden rounded-lg shadow">
            <iframe 
              src="https://cdn.ottlive.co.in/bharat24/embed.html"
              allow="autoplay;fullscreen" 
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                borderRadius: "8px"
              }}
              title="Live TV Stream"
            />
          </div> */}
          
        </div>
        <div className='articles'>
          <h2 className={`text-xl capitalize font-bold mb-6 ${darkMode ? HEADING_STYLE_DARK_MODE : HEADING_STYLE_LIGHT_MODE}`}>
            {"ताजा खबरें"}
          </h2>
          {articles?.map((news, index) => (
            index === 0 ? (
              <Newsgrid news={news} darkMode={darkMode} fontSize={fontSize} key={news.id || index} />
            ) : index % 3 !== 0 ? (
              <Newsgrid2 news={news} darkMode={darkMode} fontSize={fontSize} key={news.id || index} />
            ) : (
              <Newsgrid3 news={news} darkMode={darkMode} fontSize={fontSize} key={news.id || index} />
            )
          ))}
        </div>
      </>
    );
  };

  return (
    <div className={`font-sans min-h-screen ${darkMode ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-900'}`}>
      <main
        className="px-3 category-container"
        ref={newsContainerRef}
        style={{ height: `calc(100vh - ${fooNavHeight+10}px)`, overflowY: 'auto', paddingTop:headerHeight+10}}   
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        <div className="player-container">
          <h2 className={`text-xl capitalize font-bold mb-6 ${darkMode ? HEADING_STYLE_DARK_MODE : HEADING_STYLE_LIGHT_MODE}`}>
            {"Live Tv"}
          </h2>
          {renderContent()}
        </div>
      </main>
    </div>
  );
}
